/**
 * ExXtra Add To Cart
 * ---------------------------------------------------------
 * Shared helper for all ExXtra booking services.
 *
 * Supports:
 * - Valet Storage
 * - Device Destruction
 * - Pack & Move
 * - Future booking products
 */

window.ExXtraAddToCart = (() => {

    async function add({

    variantId,

    sellingPlan = null,

    quantity = 1,

    properties = {},

    address = null,

    service = "generic",

    redirect = true

    }) {

        if (!variantId) {

            throw new Error(
                "Variant ID is required."
            );

        }

        /*
        |--------------------------------------------------------------------------
        | Save booking locally
        |--------------------------------------------------------------------------
        */

        localStorage.setItem(
            "exxtra_booking_service",
            service
        );

        localStorage.setItem(
            "exxtra_booking_address",
            JSON.stringify(address || {})
        );

        localStorage.setItem(
            "exxtra_booking_properties",
            JSON.stringify(properties || {})
        );

        // Clear stale Valet Storage data.
        localStorage.removeItem("valet_booking_address");
        localStorage.removeItem("valet_booking_properties");

        try {

            const response = await fetch(
                "/cart/add.js",
                {

                    method: "POST",

                    headers: {

                        "Content-Type":
                            "application/json",

                        "Accept":
                            "application/json"

                    },

                    body: JSON.stringify({

                        id: variantId,

                        quantity,

                        selling_plan: sellingPlan,

                        properties

                    })

                }
            );

            if (!response.ok) {

                const error =
                    await response.json();

                throw new Error(

                    error.description ||

                    "Unable to add product."

                );

            }

            const item =
                await response.json();
                            /*
            |--------------------------------------------------------------------------
            | Redirect to checkout
            |--------------------------------------------------------------------------
           

            if (redirect) {

                const fullName =
                    address?.fullName || "";

                const parts =
                    fullName
                        .trim()
                        .split(/\s+/);

                const params =
                    new URLSearchParams({

                        'checkout[shipping_address][first_name]':
                            parts[0] || '',

                        'checkout[shipping_address][last_name]':
                            parts.slice(1).join(' ') || '',

                        'checkout[shipping_address][company]':
                            address?.unit || '',

                        'checkout[shipping_address][address1]':
                            address?.line1 || '',

                        'checkout[shipping_address][address2]':
                            address?.line2 || '',

                        'checkout[shipping_address][zip]':
                            address?.postcode || '',

                        'checkout[shipping_address][country]':
                            'Singapore',

                        'checkout[shipping_address][phone]':
                            address?.phone || '',

                        'checkout[billing_address][first_name]':
                            parts[0] || '',

                        'checkout[billing_address][last_name]':
                            parts.slice(1).join(' ') || '',

                        'checkout[billing_address][company]':
                            address?.unit || '',

                        'checkout[billing_address][address1]':
                            address?.line1 || '',

                        'checkout[billing_address][address2]':
                            address?.line2 || '',

                        'checkout[billing_address][zip]':
                            address?.postcode || '',

                        'checkout[billing_address][country]':
                            'Singapore',

                        'checkout[billing_address][phone]':
                            address?.phone || ''

                    });

                window.location.href =
                    `/checkout?${params.toString()}`;

            } */
            /*
            |--------------------------------------------------------------------------
            | Redirect to Cart
            |--------------------------------------------------------------------------
            */

            if (redirect) {
                window.location.href = "/cart";
            }

            return item;

        } catch (error) {

            console.error(
                "[ExXtra Add To Cart]",
                error
            );

            throw error;

        }

    }

    return {

        add

    };

})();